module.exports = __webpack_public_path__ + "static/media/activityActiveIcon.199b0432.svg";